import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// azordi.app/s/Ab3xYz → resolves to the long form / instructions / deposit URL and redirects.
export default function ShortLink() {
  const { code } = useParams();
  const [err, setErr] = useState("");
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/s/${encodeURIComponent(code)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("This link has expired or doesn't exist."))))
      .then((d) => { const p = d.path || "/"; window.location.replace(p.startsWith("http") ? p : `${window.location.origin}${p}`); })
      .catch((e) => setErr(e.message));
  }, [code]);
  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center text-sm text-muted-foreground" data-testid="short-link-page">
      {err ? <div data-testid="short-link-error">{err}</div> : <div>Opening…</div>}
    </div>
  );
}
